import { createSlice } from "@reduxjs/toolkit";
import {
  createOrderBuilder,
  getUserOrdersBuilder,
  getOrderByIdBuilder,
  getAllOrdersBuilder,
  updateOrderStatusBuilder,
  addTrackingNumberBuilder,
  getOrderStatisticsBuilder,
} from "./builder";

const initialState = {
  userOrders: {
    data: null,
    pagination: {
      page: 1,
      totalPages: 1,
      total: 0,
      limit: 10,
    },
  },
  allOrders: {
    data: null,
    pagination: {
      page: 1,
      totalPages: 1,
      total: 0,
      limit: 10,
    },
  },
  selectedOrder: null,
  createdOrder: null,
  statistics: null,
  loading: {
    createOrder: false,
    getUserOrders: false,
    getOrderById: false,
    getAllOrders: false,
    updateOrderStatus: false,
    addTrackingNumber: false,
    getOrderStatistics: false,
  },
  errors: {
    createOrder: null,
    getUserOrders: null,
    getOrderById: null,
    getAllOrders: null,
    updateOrderStatus: null,
    addTrackingNumber: null,
    getOrderStatistics: null,
  },
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    clearCreatedOrder: (state) => {
      state.createdOrder = null;
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    clearSelectedOrder: (state) => {
      state.selectedOrder = null;
    },
    clearOrderErrors: (state) => {
      state.errors = { ...initialState.errors };
    },
  },
  extraReducers: (builder) => {
    createOrderBuilder(builder);
    getUserOrdersBuilder(builder);
    getOrderByIdBuilder(builder);
    getAllOrdersBuilder(builder);
    updateOrderStatusBuilder(builder);
    addTrackingNumberBuilder(builder);
    getOrderStatisticsBuilder(builder);
  },
});

export const { clearCreatedOrder, setSelectedOrder, clearSelectedOrder, clearOrderErrors } =
  ordersSlice.actions;

// Selectors
export const selectUserOrders = (state) => state.orders.userOrders.data;
export const selectUserOrdersPagination = (state) => state.orders.userOrders.pagination;
export const selectAllOrders = (state) => state.orders.allOrders.data;
export const selectAllOrdersPagination = (state) => state.orders.allOrders.pagination;
export const selectSelectedOrder = (state) => state.orders.selectedOrder;
export const selectCreatedOrder = (state) => state.orders.createdOrder;
export const selectOrderStatistics = (state) => state.orders.statistics;

export const selectOrdersLoading = (state) => state.orders.loading;
export const selectOrdersErrors = (state) => state.orders.errors;

export const selectCreateOrderLoading = (state) => state.orders.loading.createOrder;
export const selectGetUserOrdersLoading = (state) => state.orders.loading.getUserOrders;
export const selectGetOrderByIdLoading = (state) => state.orders.loading.getOrderById;
export const selectGetAllOrdersLoading = (state) => state.orders.loading.getAllOrders;
export const selectUpdateOrderStatusLoading = (state) => state.orders.loading.updateOrderStatus;
export const selectGetOrderStatisticsLoading = (state) => state.orders.loading.getOrderStatistics;

export default ordersSlice.reducer;